import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const ClockWidget = () => {
  const serverTimeDate = useSelector((state) => state.store.home.serverTimeDate);
  const [localTime, setLocalTime] = useState(null);

  useEffect(() => {
    if (!serverTimeDate || !serverTimeDate.date) return;

    const initialTime = new Date(Date.UTC(
      new Date(serverTimeDate.date).getUTCFullYear(),
      new Date(serverTimeDate.date).getUTCMonth(),
      new Date(serverTimeDate.date).getUTCDate(),
      new Date(serverTimeDate.date).getUTCHours(),
      new Date(serverTimeDate.date).getUTCMinutes(),
      new Date(serverTimeDate.date).getUTCSeconds()
    ));

    setLocalTime(initialTime);

    // Set up an interval to update the local time every second
    const id = setInterval(() => {
      setLocalTime((prevTime) => {
        // Increment the time by 1 second without timezone adjustments
        const updatedTime = new Date(prevTime.getTime() + 1000);

        return updatedTime;
      });
    }, 1000);

    return () => clearInterval(id);
  }, [serverTimeDate]);

  const formatTime = (date) => {
    const hours = date.getUTCHours();
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const period = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = String(hours % 12 || 12).padStart(2, '0'); // Convert to 12-hour format
    // return `${formattedHours}:${minutes} ${ampm}`;
    return {
      hours: formattedHours,
      minutes,
      period,
    };
  };

  const formatDate = (date) => {
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    const dayName = days[date.getUTCDay()];
    const monthName = months[date.getUTCMonth()];
    const day = String(date.getUTCDate()).padStart(2, '0');

    // return `${dayName}, ${monthName} ${day}`;
    return {
      dayName,
      monthName,
      day,
    };
  };

  return (
   
    <div className="alarm-clock">
      {/* <div className="alarm-title">Weather</div> */}
      <div className="clock-main">
        <div className="date-time-container">
          {localTime ? (
            <>
              <div className="time-main">
                {formatTime(localTime).hours}:{formatTime(localTime).minutes}
                <span className="period">{formatTime(localTime).period}</span>
              </div>
              <div className="date-main">
                <span className="day">{formatDate(localTime).dayName}</span>,
                <span className="month"> {formatDate(localTime).monthName}</span>
                <span className="date"> {formatDate(localTime).day}</span>
              </div>
            </>
          ) : (
            'Loading...'
          )}
        </div>
        {/* <div className="add-alarm">
          <a className="add-alarm">
            <i className="fa fas fa-plus"></i>
          </a>
        </div> */}
      </div>
      {/* <div className="alarm-selector">
        <select className="hour">
          <option>1</option>
          <option>2</option>
          <option>3</option>
          <option>4</option>
          <option>5</option>
          <option>6</option>
          <option>7</option>
          <option>8</option>
          <option>9</option>
          <option>10</option>
          <option>11</option>
          <option>12</option>
        </select>
        <span className="breaker">:</span>
        <select className="minute">
          <option>00</option>
          <option>15</option>
          <option>30</option>
          <option>45</option>
        </select>
        <span className="breaker">:</span>
        <select className="period">
          <option>AM</option>
          <option>PM</option>
        </select>
        <div className="breaker controls">
          <a className="button save"><i className="fa fas fa-plus"></i></a>
          <a className="button remove"><i className="fa fas fa-minus"></i></a>
        </div>
      </div>
      <div className="alarm-list">
        <div className="alarm-list-heading">Alarm</div>
        <div className="alarm-item-container">
          <div className="alarm-item">
            <div className="alarm-time">9:30<span className="period">AM</span></div>
            <div className="alarm-toggle">
              <label className="switch">
                <input className="alarm-switch" type="checkbox" className="unlock"/><span className="slider round focusable"></span>
              </label>
            </div>
          </div>
          <div className="alarm-item">
            <div className="alarm-time">9:30<span className="period">AM</span></div>
            <div className="alarm-toggle">
              <label className="switch">
                <input className="alarm-switch" type="checkbox" className="unlock"/><span className="slider round focusable"></span>
              </label>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default ClockWidget;
